import { defineMessages } from 'react-intl'

const subjectsMessages = defineMessages({
  czech: {
    id: 'subject.czech',
    defaultMessage: 'Čeština',
  },
  english: {
    id: 'subject.english',
    defaultMessage: 'Angličtina',
  },
  german: {
    id: 'subject.german',
    defaultMessage: 'Nemčina',
  },
  french: {
    id: 'subject.french',
    defaultMessage: 'Francúzština',
  },
  slovak: {
    id: 'subject.slovak',
    defaultMessage: 'Slovenčina',
  },
  spanish: {
    id: 'subject.spanish',
    defaultMessage: 'Španielčina',
  },
  russian: {
    id: 'subject.russian',
    defaultMessage: 'Ruština',
  },
  /* **************** */
  mathematics: {
    id: 'subject.mathematics',
    defaultMessage: 'Matematika',
  },
  physics: {
    id: 'subject.physics',
    defaultMessage: 'Fyzika',
  },
  chemistry: {
    id: 'subject.chemistry',
    defaultMessage: 'Chémia',
  },
  biology: {
    id: 'subject.biology',
    defaultMessage: 'Biológia',
  },
  history: {
    id: 'subject.history',
    defaultMessage: 'Dejepis',
  },
  geography: {
    id: 'subject.geography',
    defaultMessage: 'Geografia',
  },
})

export default subjectsMessages



// WEBPACK FOOTER //
// ./src/common/translations/subjectsMessages.js